var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { statusJoin as statusJoinAction, uidRecoverConfirm as uidRecoverConfirmAction } from '../../../actions/auth/creators/Forgot';
import Form from '../changePassword/PasswordForm';
import { getQueryVariable } from '../../../shared/sharedFunctions';
import { defineMessages, FormattedMessage } from 'react-intl';
import { getProductId, getSourceId } from '../../../shared/domainUtils';
var messages = defineMessages({
    title: {
        id: 'forgot.recovery.title',
        defaultMessage: 'Восстановление пароля'
    },
    recoveryOrderInvalid: {
        id: 'forgot.errors.order_invalid',
        defaultMessage: 'Ссылка недействительна'
    },
    recoveryOrderAbsent: {
        id: 'forgot.errors.order_absent',
        defaultMessage: 'Не указан идентификатор'
    }
});
var RecoverPassword = /** @class */ (function (_super) {
    __extends(RecoverPassword, _super);
    function RecoverPassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            passwordNotMatch: false,
            uid: undefined
        };
        _this.handleSubmit = function (values) {
            var data = {
                'source': getSourceId(_this.props.countryCode),
                'product': getProductId(),
                'RecoveryUid': _this.state.uid,
                'NewPassword': values.newpassword
            };
            if (values.newpassword !== values.confpassword) {
                _this.setState({
                    passwordNotMatch: true
                });
            }
            else {
                _this.props.uidRecoverConfirmAction(data);
            }
        };
        return _this;
    }
    RecoverPassword.prototype.componentDidMount = function () {
        var uid = getQueryVariable('uid');
        var data = {
            'source': getSourceId(this.props.countryCode),
            'product': getProductId(),
            'uid': uid
        };
        this.setState({
            uid: uid
        });
        this.props.statusJoinAction(data);
    };
    RecoverPassword.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.recover.uidConfirmState !== nextProps.recover.uidConfirmState &&
            nextProps.recover.uidConfirmState === 0) {
            alert('Пароль успешно восстановлен');
            this.props.history.push('/');
        }
    };
    RecoverPassword.prototype.render = function () {
        var _a = this.props, recover = _a.recover, languageId = _a.languageId;
        var passwordNotMatch = this.state.passwordNotMatch;
        var uidState = recover.uidConfirmState;
        var status = recover.statusState;
        var props = {
            submitAction: this.handleSubmit,
            passwordNotMatch: passwordNotMatch,
            languageId: languageId,
        };
        var child = '';
        if (status === 2) {
            child = (_jsx("div", __assign({ className: 'important' }, { children: _jsx(FormattedMessage, __assign({}, messages.recoveryOrderInvalid)) })));
        }
        else if (status === -2) {
            child = (_jsx("div", __assign({ className: 'important' }, { children: _jsx(FormattedMessage, __assign({}, messages.recoveryOrderAbsent)) })));
        }
        else {
            child = (_jsx(Form, __assign({}, props)));
        }
        return (_jsxs("div", __assign({ id: 'content' }, { children: [_jsx("div", __assign({ className: 'backward' }, { children: _jsx("div", __assign({ className: 'header' }, { children: _jsx("div", __assign({ className: 'title' }, { children: _jsx(FormattedMessage, __assign({}, messages.title)) })) })) })), _jsxs("div", __assign({ className: 'block blc_signup' }, { children: [uidState === -100 && _jsx("div", __assign({ className: 'important' }, { children: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430! \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u0437\u0436\u0435" })), _jsx("div", __assign({ className: 'forms' }, { children: child }))] }))] })));
    };
    return RecoverPassword;
}(React.Component));
RecoverPassword.propTypes = {
    uidRecoverConfirmAction: PropTypes.func.isRequired,
    statusJoinAction: PropTypes.func.isRequired,
    recover: PropTypes.object.isRequired,
};
var mapStateToProps = function (state) { return ({
    recover: state.recover,
    languageId: state.application.get('languageId'),
    countryCode: state.application.get('client').country,
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    uidRecoverConfirmAction: uidRecoverConfirmAction,
    statusJoinAction: statusJoinAction
}, dispatch); };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RecoverPassword));



// WEBPACK FOOTER //
// ./src/components/shared/recovery/index.js